import { cn } from '../../../lib/cn';

/** A 4-step password strength bar (0–4). */
export function passwordStrength(pw: string): number {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 6) s++;
  if (pw.length >= 10) s++;
  if (/\d/.test(pw) && /[a-zA-Z]/.test(pw)) s++;
  if (/[^a-zA-Z0-9]/.test(pw)) s++;
  return Math.min(4, s);
}

const STRENGTH_LABEL = ['', 'Weak', 'Fair', 'Good', 'Strong'];

export function StrengthMeter({ value }: { value: string }) {
  const score = passwordStrength(value);
  if (!value) return null;
  const tone =
    score <= 1 ? 'bg-miss' : score === 2 ? 'bg-gold-bottom' : 'bg-accent';
  return (
    <div className="mt-2 flex items-center gap-2">
      <div className="flex flex-1 gap-1">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className={cn('h-1 flex-1 rounded-full', i < score ? tone : 'bg-fill')}
          />
        ))}
      </div>
      <span
        className={cn(
          'w-12 text-right text-[11px] font-bold',
          score <= 1 ? 'text-miss' : score === 2 ? 'text-gold-bottom' : 'text-accent-ink'
        )}
      >
        {STRENGTH_LABEL[score]}
      </span>
    </div>
  );
}
